/**
 * PrivateMark — small lock shown next to a private task's title. Private tasks
 * are only ever returned to their owner, so the mark is a reminder ("only you
 * see this"), not an access control.
 */

import { Icon } from '@/components/Icon';
import type { Task } from './api';

export function PrivateMark({ task, size = 11 }: { task: Pick<Task, 'soukromy'>; size?: number }) {
  if (task.soukromy !== 1) return null;
  return (
    <span className="inline-flex flex-shrink-0 text-ink-3" data-testid="ukol-soukromy-mark">
      <Icon name="lock" size={size} title="Soukromý úkol — vidíš ho jen ty" />
    </span>
  );
}
